<template>
    <div>
        <div class="input-error" v-for="(errorMessage, index) in errorMessages" :key="index">{{ errorMessage }}</div>
    </div>
</template>
<script>
export default {
    props: {
        errorMessage: {
            type: [String, Array],
            required: false,
        },
    },
    computed: {
        errorMessages() {
            if (!this.errorMessage) {
                return []
            }

            return Array.isArray(this.errorMessage) ? this.errorMessage : [this.errorMessage]
        },
    },
}
</script>
